import React from 'react';
import { useMessage } from '@tmapy/intl';

import '../../app/components/Badge.scss';

import { Badge, DangerBadge, Icon, InfoBadge, SuccessBadge, SvgSpinner } from '@tmapy/style-guide';

import { ORDER_STATE } from '../constants';
import { orderStateMessages } from './orderMessages';

type OrderBadgeProps = {
  state: ORDER_STATE;
};

export const OrderBadge: React.FC<OrderBadgeProps> = ({ state }) => {
  const formatMessage = useMessage();
  const stateText = formatMessage.lookup(orderStateMessages, ORDER_STATE[state]);

  switch (state) {
    case ORDER_STATE.APPROVED:
    case ORDER_STATE.PUBLISHED: {
      return (
        <SuccessBadge isStrong>{stateText}</SuccessBadge>
      );
    }
    case ORDER_STATE.PROCESSING:
    case ORDER_STATE.WAITING_FOR_APPROVAL:
    case ORDER_STATE.WAITING_FOR_INTERRUPTION:
    case ORDER_STATE.WAITING_FOR_PROCESSING: {
      return (
        <Badge unsafeClassName='dmx-badge--in-progress'>
          <div className='sg-a-d-f sg-a-ai-c'>
            <Icon element={<SvgSpinner />} />
            <span className='sg-a-ml-1/2 sg-a-ws-nw'>{stateText}</span>
          </div>
        </Badge>
      );
    }
    case ORDER_STATE.EXPIRED:
    case ORDER_STATE.INTERRUPTED: {
      return (
        <InfoBadge>{stateText}</InfoBadge>
      );
    }
    case ORDER_STATE.DMVS_COMMUNICATION_FAILED:
    case ORDER_STATE.REJECTED: {
      return (
        <DangerBadge>{stateText}</DangerBadge>
      );
    }
    case ORDER_STATE.FAILED: {
      return (
        <DangerBadge isStrong>{stateText}</DangerBadge>
      );
    }
    default: {
      console.error('OrderBadge: Unknown state', state);
      return state;
    }
  }
};
